<template>
  <div>
    <div class="form-check">
      <input class="form-check-input"
        type="checkbox"
        v-model="internalModel"
        v-bind="getFieldProperties"
        @focus="onFocus"
        @blur="onBlur"
        @change="updateValue($event.target.checked)"
      />
      <span class="faux-checkbox"></span>
      <label class="form-checkbox__label" :for="id" v-html="labelText" />
      <p v-if="helpText" v-html="helpText" class="h5 mt--2x" />
    </div>
    <form-errors :errors="errors" />
  </div>
</template>

<script>
// import FormControlMixin from '@/js/mixins/FormControlMixin';
import FormControlMixin from '../../mixins/FormControlMixin';

export default {
  mixins: [FormControlMixin],
  props: {
    options: { type: Object, required: false },
    checked: {
      type: [Number, Boolean],
      default: 0,
    },
  },
  data() {
    return {
      internalModel: this.checked,
    };
  },
  model: {
    prop: 'checked',
    event: 'change',
  },
  computed: {
    getFieldProperties() {
      return {
        name: this.name,
        class: 'form-checkbox',
        disabled: this.isDisabled,
        required: this.required,
        value: this.value,
        id: this.id,
      };
    },
  },
  methods: {
    updateValue(checked) {
      this.$emit('change', checked);
    },
  },
};
</script>
